(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-v2"] && !Shopify.designMode) return;
  try {
    
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this._speed = +this.getAttribute('data-speed') || 500;
    this._interval = +this.getAttribute('data-interval') || 5000;
    this._direction = this.getAttribute('data-direction') || 'ltr';
    this._height = +this.getAttribute('data-height') || 40;
  }

  connectedCallback() {
    const bar = document.getElementById('shopify-section-announcement-v2')
    const barHeight = !!bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', barHeight + 'px');

    if (window.Splide) {
      const splide = new Splide(this.querySelector('.splide.announcements'), {
        type: 'loop',
        direction: this._direction,
        height: this._direction === 'ttb' ? this._height : undefined,
        perPage: 1,
        autoplay: true,
        pauseOnHover: false,
        interval: this._interval,
        speed: this._speed,
        arrows: false,
        pagination: false,
      });

      splide.mount()
    } else {
      console.error('Splide is not defined.');
    }
  }
}

if (window.customElements) {
  customElements.define('announcement-bar', AnnouncementBar);
} else {
  document.registerElement('announcement-bar', AnnouncementBar);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-free-product"] && !Shopify.designMode) return;
  try {
    
class PopupModal extends HTMLElement {
  _cart;
  _productId;
  _delay;
  _priceTarget;
  _autoRemove;
  constructor() {
    super();
    this._productId = this.getAttribute('data-product-id');
    this._delay = this.getAttribute('data-delay');
    this._priceTarget = parseFloat(this.getAttribute('data-target'));
    this._fade_duration = this.getAttribute('data-fade-duration') || 1000;
    this._autoRemove = this.getAttribute('data-auto-remove') === 'true';
    this.handleCartItems();
  }

  connectedCallback() {
    this._modal = this.querySelector('.modal');

    document.addEventListener('product:added', () => {
      this.handleCartItems()
    });

    document.addEventListener('product:changed', () => {
      this.handleCartItems()
    })
  }

  async handleCartItems() {
    await this.fetchCartDetails();
    await this.fetchCartDetails();
    const totalPrice = this._cart.total_price / 100
    const isAlreadyInCart = this.isFreeProductInCart();
    const isNotInCart = !isAlreadyInCart;

    if (totalPrice >= this._priceTarget && isNotInCart) {
      setTimeout(() => {
        this.openModal();
      }, this._delay);
    } else if (totalPrice < this._priceTarget && isAlreadyInCart) {
      if (this._autoRemove) {
        const variantId = this.getFirstVariantId();
        this.removeFromCart(variantId)

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        const isInCartPage = window.location.pathname.includes('/cart');
        if (isInCartPage) {
          setTimeout(() => {
            window.location.reload();
          }, 1000)
        }
      }
    }
  }

  async fetchCartDetails () {
    try {
      const cartData = await fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          return data;
        });

      this._cart = cartData;
    } catch (error) {
      console.error(error)
    }
  }

  isFreeProductInCart() {
    return this._cart.items.some(item => (item.product_id + '') === (this._productId + ''));
  }

  getFirstVariantId() {
    const items = this._cart.items.find(item => (item.product_id + '') === (this._productId + ''))
    return items.variant_id;
  }


  async removeFromCart(variantId) {
    try {
      let data = {
        id: variantId.toString(),
        quantity: 0
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const cart = await response.json();
      this._cart = cart;
      console.log('Product removed from cart:', cart);
    } catch (error) {
      console.error('Error removing product from cart:', error);
    }
  }

  openModal() {
    const header = document.querySelector('.Header__Wrapper');

    if (header) {
      const box = header.getBoundingClientRect();
      window.scrollTo(0, box.top)
    }

    $(this._modal).modal({
      fadeDuration: this._fade_duration,
      clickClose: false,
    });
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 210);

    const windowHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--window-height', `${window.innerHeight}px`)
    }
    document.addEventListener('resize', windowHeight);
    windowHeight();
  }
}

if (!customElements.get('free-popup-modal')) {
  customElements.define('free-popup-modal', PopupModal);
}

  } catch(e) { console.error(e); }
})();
})();
